<template>
  <vs-popup
    :title="'Edit setup floorplan: ' + (setup ? setup.name : '')"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    :accept-text="'Save floorplan'"
    class="edit-floorplan-popup">
    <vs-row vs-w="12" class="edit-floorplan-popup-content">
      <vs-col vs-w="12">

      <div class="text-center p-16" v-if="isLoading">
        <p class="opacity-60">Finding setups</p>
        <span class="flex h-12 w-12 mx-auto mt-5">
          <span class="animate-ping absolute inline-flex h-12 w-12 rounded-full bg-primary opacity-75"></span>
          <span  class="relative inline-flex rounded-full h-12 w-12 bg-primary"
          ></span>
        </span>
      </div>
      <div v-if="!isLoading" class="relative">
        <!--Floorplan-->
        <div style="height:calc(100vh - 225px);  ">
          <floorplan-canvas :leftOffset="250" :isEdit="true" @onEscape="onEscape()" @onTableDeleted="tableDeleted($event)" @onDrawing="onDrawing" @onMoveButtonClicked="onMoveButtonClicked($event)" @onZoom="onZoom($event)" ref="floorplancanvas"></floorplan-canvas>
        </div>
        <!--Overview-->
        <div class="shadow-lg p-6 rounded absolute w-64 overflow-auto" style="
          top: 12px;
          left: 12px;
          background: white;
          bottom: 12px;
          ">
          <p class="text-grey leading-relaxed" style="line-height:1"><small>Click element to find it on floorplan</small></p>
          <div v-for="(section, index) of this.setup.venueSections" :key="index" class="mb-4">
            <div class="flex justify-between">
              <h6 class="mt-auto mr-8 cursor-pointer" @click="searchSection(section.id)">{{section.name}}</h6>
              <div>
                <vs-button class="p-1 h-6 w-6" :type="drawingSection == section ? 'filled' : 'flat'"  size="small" @click="toggleDrawing(section)">
                  <feather-icon
                    :icon="drawingSection == section ? 'StopCircleIcon' :'Edit2Icon'"
                    class=""
                    svgClasses="h-4 w-4 my-auto">
                  </feather-icon>
                </vs-button>
              </div>
            </div>
            <div style="border-bottom: 1px solid #f3f3f3; margin-bottom: 0.5rem; margin-top: 0.5rem;"></div>
            <div v-for="(table, index) of section.venueTables" :key="'table' + index" class="mb-2">
              <div class="flex justify-between">
                <p><span class="cursor-pointer" @click="searchTable(table.id)">{{table.name}}</span>
                  <feather-icon
                    v-if="table.isPlaced"
                    :icon="'CheckIcon'"
                  class="text-primary ml-4"
                    svgClasses="h-4 w-4 my-auto">
                  </feather-icon>
                </p>
                <div>
                  <vs-button class="p-1 h-6 w-6" :type="drawingTable == table ? 'filled' : 'flat'" size="small" @click="toggleDrawingTable(table)">
                  <feather-icon
                    :icon="'MoveIcon'"
                    class=""
                    svgClasses="h-4 w-4 my-auto">
                  </feather-icon>
                </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Ruler-->
        <div class="absolute" style="
          bottom: 12px;
          left: 255px;">
          <div style="
            height: 5px;
            border-bottom: solid 2px #0074d9;
            border-left: solid 2px #0074d9;
            border-right: solid 2px #0074d9;" :style="{'width': zoomLev + 'px'}"></div>
            <p class="mt-1 mb-0">5m</p>
        </div>

        <!--Utility-->
        <div class="absolute flex" style="
          top: 12px;
          left: 244px;">
          <div class="shadow-lg p-2 rounded flex" style="background:white" @click="toggleDrawingIcon(iconTypes.RestroomUnisex)">
            <svg class="w-4 my-auto" style="fill: rgb(64, 64, 64);" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"><path d="M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"/></svg>
          </div>
          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white" @click="toggleDrawingIcon(iconTypes.Wardrobe)">
            <svg class="w-4 my-auto" style="fill: rgb(64, 64, 64);" viewBox="0 0 468.765 334.905" xmlns="http://www.w3.org/2000/svg"><defs id="defs3823"><marker id="ArrowEnd" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="0" refY="5" viewBox="0 0 10 10"><path d="M 0 0 L 10 5 L 0 10 z" id="path3826"/></marker><marker id="ArrowStart" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="10" refY="5" viewBox="0 0 10 10"><path d="M 10 0 L 0 5 L 10 10 z" id="path3829"/></marker></defs><g id="g3831"><path d="M 20.5798 251.652C 0.890778 263.269 -2.66223 288.001 1.60777 303.006C 5.74977 317.558 20.3498 334.905 46.6228 334.905L 46.6818 334.905C 46.6818 334.905 385.442 334.905 419.603 334.905C 449.02 334.905 462.434 318.042 466.575 303.49C 470.845 288.485 470.845 265.251 448.071 251.214L 250.58 134.652L 250.58 114.806C 250.58 92.298 226.026 82.527 226.026 82.527C 210.133 74.782 211.556 58.084 211.556 58.084C 211.556 38.482 229.111 32.189 236.937 32.189C 250.08 32.189 262.969 39.477 264.329 56.148C 266.465 82.286 296.08 75.652 296.08 54.652C 296.08 34.808 277.979 0 236.701 0C 192.08 0 179.264 43.629 179.264 57.424C 179.264 67.829 180.909 77.437 187.33 88.402C 198.242 107.037 220.08 109.966 220.08 122.308L 220.08 134.652L 20.5798 251.652z" id="path3833" style="stroke:none; fill:rgb(64, 64, 64)"/><path d="M 234.092 164.574L 427.58 277.652C 439.58 286.152 433.08 302.152 420.08 302.179L 47.2148 302.179C 35.0798 302.652 27.5798 285.652 39.5798 278.152L 234.092 164.574z" id="path3835" style="stroke:none; fill:#ffffff"/></g></svg>
          </div>
          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white" @click="toggleDrawingIcon(iconTypes.Exit)">
            <svg class="w-4 my-auto" style="fill: rgb(64, 64, 64);" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M27,3V29a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V27H7v1H25V4H7V7H5V3A1,1,0,0,1,6,2H26A1,1,0,0,1,27,3ZM10.71,20.29,7.41,17H18V15H7.41l3.3-3.29L9.29,10.29l-5,5a1,1,0,0,0,0,1.42l5,5Z" id="logout_account_exit_door"/></g></svg>
          </div>
          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white" @click="toggleDrawingIcon(iconTypes.Window)">
            <svg class="w-4 my-auto" style="fill: rgb(64 64 64 / 0%); stroke: rgb(64, 64, 64); stroke-width: 2; stroke-linejoin: round;" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M 4 1 L 28 1 L 28 31 L 4 31 L 4 1 M 4 16 L 28 16 M 16 1 L 16 31" id="logout_account_exit_door"/></g></svg>
          </div>
          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white" @click="toggleDrawingIcon(iconTypes.Door1)">
            <svg class="w-4 my-auto" style="fill: rgb(64 64 64 / 0%); stroke: rgb(64, 64, 64); stroke-width: 2; stroke-linejoin: round;" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M 1 1 A 30 30 0 0 0 31 31 L 31 1" id="logout_account_exit_door"/></g></svg>
          </div>
          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white" @click="toggleDrawingIcon(iconTypes.Door2, 1)">
            <svg class="w-4 my-auto" style="fill: rgb(64 64 64 / 0%); stroke: rgb(64, 64, 64); stroke-width: 2; stroke-linejoin: round;" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M 1 8 L 1 24 A 14 14 0 0 0 16 8 A 14 14 0 0 0 31 24 L 31 8"></path></g></svg>
          </div>
          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white" @click="toggleDrawingIcon(iconTypes.Stairs)">
            <svg class="w-4 my-auto" style="fill: rgb(64, 64, 64);" viewBox="0 0 439.752 365.145" id="svg1317" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:svg="http://www.w3.org/2000/svg"><defs id="defs1319"><marker id="ArrowEnd" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="0" refY="5" viewBox="0 0 10 10"><path d="M 0 0 L 10 5 L 0 10 z" id="path1322"/></marker><marker id="ArrowStart" markerHeight="3" markerUnits="strokeWidth" markerWidth="4" orient="auto" refX="10" refY="5" viewBox="0 0 10 10"><path d="M 10 0 L 0 5 L 10 10 z" id="path1325"/></marker></defs><g id="g1327"><path d="M 0 323.974L 80.05 323.974L 80.05 242.499L 159.584 242.499L 159.584 160.474L 240.373 160.474L 240.373 79.974L 320.614 79.974L 320.614 0L 439.752 0L 439.752 40.804L 360.55 40.804L 360.55 121.082L 280.218 121.082L 280.218 202.49L 200.05 202.49L 200.05 283.474L 119.55 283.474L 119.55 365.145L 0 365.145L 0 323.974z" id="path1329" style="stroke:none; fill:rgb(64, 64, 64)"/></g></svg>
          </div>
          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white">
            <div class="w-4 flex"  @click="toggleDrawingText()">
              <svg style="fill: rgb(64, 64, 64);" class="my-auto" enable-background="new 0 0 32 32"  id="svg2" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:svg="http://www.w3.org/2000/svg"><g id="background"><rect fill="none" height="32" width="32"/></g><g id="text"><polygon points="4,6 4,10 12,10 12,28 16,28 16,10 24,10 24,6  "/><polygon points="30,4 30,2 24,2 24,4 26,4 26,28 24,28 24,30 30,30 30,28 28,28 28,4  "/></g></svg>
            </div>
            <vs-input v-if="currentText" class="inputx ml-2 mr-2" placeholder="Label text" v-model="currentText.text" ref="textInput"/>


            <vs-select class="inputx w-24 ml-2" v-if="currentText"
              v-model="currentText.fontSize" >
              <vs-select-item :key="index" :value="fontSize.size" :text="fontSize.label" v-for="(fontSize,index) in fontSizes" />
            </vs-select>

            <vs-select class="inputx w-24 ml-2" v-if="currentIcon"
              v-model="currentIcon.iconSize" >
              <vs-select-item :key="index" :value="iconSize.size" :text="iconSize.label" v-for="(iconSize,index) in iconSizes" />
            </vs-select>
          </div>

          <div class="shadow-lg p-2 rounded ml-2 flex" style="background:white" @click="toggleDelete()">
            <feather-icon
                  icon="Trash2Icon"
                  class="text-primary"
                  svgClasses="h-4 w-4 my-auto">
              </feather-icon>
          </div>

          <div @click="rotate()" v-if="drawingTable || currentText || currentIcon" class="shadow-lg p-2 rounded ml-2 flex" style="background:white" >
            <feather-icon
                icon="RotateCwIcon"
                class="text-primary"
                svgClasses="h-4 w-4 my-auto">
              </feather-icon>
          </div>

          <div class="my-auto ml-4" v-if="drawingTable || currentIcon">
            <p>Press 'r'-key to rotate</p>
          </div>

          <div class="my-auto ml-4" v-if="drawingSection">
            <p v-if="!hasStartedPolygon">Click on canvas to add point. Press 'esc'-key to cancel</p>
            <p v-if="hasStartedPolygon">Press 'enter'-key or click on first point to finish drawing. Press 'esc'-key to cancel</p>
          </div>
        </div>
      </div>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        color="primary"
        :disabled="!(validForm)"
        @click="handleSaveFloorplanClick"
        >Save Floorplan</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS} from "@/store/modules/marcom/marcom";
import FloorplanCanvas from '../components/FloorplanCanvas.vue'
import { FloorplanIconType } from '@/store/modules/marcom/data-model/floorplan/floorplan.js';

export default {
  components: { FloorplanCanvas },
  data() {
    const that = this;
    return {
      setup: null,
      setupName:'',

      showThisPopup: false,
      hasLoadedProducts: false,

      drawingSection:null,
      drawingTable:null,
      currentText:null,
      currentIcon:null,

      hasStartedPolygon:false,

      iconTypes: new FloorplanIconType(),
      isLoading: true,

      zoomLev: 100,

      fontSizes: [
        { size: 0.7, label: 'Small'},
        { size: 1.6, label: 'Large'},
      ],

      iconSizes: [
        { size: 0.5, label: 'Small'},
        { size: 1.0, label: 'Medium'},
        { size: 1.5, label: 'Large'}
      ]
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      isLoadingLocations: "marcom/isLoadingLocations",
      activeVenueSetups: "marcom/activeVenueSetups",
    }),
    validForm() {
      return  this.setupName !== '';
    }
  },
  methods: {
    async show(setup) {
      this.hasLoadedProducts = false;
      this.setup = setup;

      this.setupName = setup.name;
      this.showThisPopup = true;
      this.isLoading = true;
      var result = await this.$store.dispatch('marcom/' + VENUE_ACTIONS.GetFloorplan, this.setup.id);
      this.isLoading = false;
      var modelTables = setup.venueSections.map(s => s.venueTables).flat();
      for (const table of result.tables.filter(i => i.itemType == "RegularTable")) {
        var modelTable = modelTables.find(mt => mt.id == table.tableId);

        if (modelTable) {
          table.isRoundTable = modelTable.isRoundTable;
          table.seatCount = modelTable.seatCount;
        }
        if (modelTable && !table.hidden)
          Vue.set(modelTable, 'isPlaced', true);
        else
          Vue.set(modelTable, 'isPlaced', false);
      }

      var self = this;
      setTimeout(() => {
        self.$refs.floorplancanvas.setFloorplanModel(result);
      }, 100);
    },
    tableDeleted(table) {
      var modelTables = this.setup.venueSections.map(s => s.venueTables).flat();
      var modelTable = modelTables.find(mt => mt.id == table.table.id);
      if (modelTable)
        setTimeout(() => Vue.set(modelTable, 'isPlaced', false), 1);
    },
    async handleSaveFloorplanClick() {
      this.$vs.loading();

      this.$vs.notify({
        color: "success",
        title: "Floorplan saved",
        text: "Your floorplan was saved",
      });

      var floorplan = this.$refs.floorplancanvas.getFloorplanModel();
      var result = await this.$store.dispatch('marcom/' + VENUE_ACTIONS.UpdateFloorplan, {
        floorplan,
        venueSetupId: this.setup.id
      });

      this.showThisPopup = false;

      this.$vs.loading.close();
    },
    handlePopupClose() {
      this.showThisPopup = true;
      //this.clonedSetup = undefined;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Closing Floorplan`,
        text: "You are about to close the floorplan without saving your work. Are you sure you want to close without saving?",
        accept: () => {
          this.showThisPopup = false;
        },
        acceptText: 'Yes, close without saving'
      });

    },
    onEscape() {
      this.drawingTable = null;
      this.drawingSection = null;
      this.currentText = null;
      this.currentIcon = null;
      this.hasStartedPolygon = false;
    },
    onDrawing(drawingLines) {
      if (drawingLines && drawingLines.points.length > 2)
        this.hasStartedPolygon = true;
      else
        this.hasStartedPolygon = false;
    },
    toggleDrawing(section) {
      this.deToggle();

      this.$refs.floorplancanvas.toggleSectionDrawing(section);
      if (this.drawingSection == section)
        this.drawingSection = null;
      else
        this.drawingSection = section;
    },
    toggleDrawingTable(table) {
      this.deToggle();

      this.$refs.floorplancanvas.toggleTableDrawing(table);
      if (this.drawingTable == table)
        this.drawingTable = null;
      else {
        this.drawingTable = table;
        Vue.set(table, 'isPlaced', true);
      }
    },
    toggleDrawingText() {
      this.deToggle();

      this.currentText = {
        text:'My text',
        rotation:0,
        fontSize: this.fontSizes[0].size
      }
      this.$refs.floorplancanvas.toggleTextDrawing(this.currentText);

      var self = this;
      setTimeout(() => {
        self.$refs.textInput.$el.children[0].children[0].select();
      }, 0);
    },
    toggleDrawingIcon(iconType, sizeIndex = 0) {
      this.deToggle();
      this.currentIcon = {
        type:iconType,
        iconSize: this.iconSizes[sizeIndex].size
      }
      this.$refs.floorplancanvas.toggleIconDrawing(this.currentIcon);
    },
    onMoveButtonClicked(moveObject) {
      if (moveObject.table) {
        this.drawingTable = moveObject;
      }
      else if (moveObject.text) {
        this.currentText = moveObject;
        var self = this;
        setTimeout(() => {
          self.$refs.textInput.$el.children[0].children[0].select();
        }, 100);
      }
      else if (moveObject.type) {
        this.currentIcon = moveObject;
      }
    },
    toggleDelete() {
      this.deToggle();

      this.$refs.floorplancanvas.toggleDelete();
    },
    deToggle() {
      if (this.drawingTable)
        this.$refs.floorplancanvas.toggleTableDrawing(this.drawingTable);
      else if (this.drawingSection)
        this.$refs.floorplancanvas.toggleSectionDrawing(this.drawingSection);
      else if (this.currentText)
        this.$refs.floorplancanvas.toggleTextDrawing(this.currentText);
      else if (this.currentIcon)
        this.$refs.floorplancanvas.toggleIconDrawing(this.currentIcon);

      this.drawingTable = null;
      this.drawingSection = null;
      this.currentText = null;
      this.currentIcon = null;
      this.hasStartedPolygon = false;
    },
    rotate() {
        this.$refs.floorplancanvas.onRotate();
    },
    searchSection(sectionId) {
      this.$refs.floorplancanvas.zoomToSection(sectionId);
    },
    searchTable(tableId){
      this.$refs.floorplancanvas.zoomToTable(tableId);
    },
    onZoom(zoomLev) {
      this.zoomLev = zoomLev * 5;
    }
  },
};
</script>

<style lang="scss" scoped>
// @keyframes fadeIn {
//   0% {
//     opacity: 0;
//   }
//   100% {
//     opacity: 1;
//   }
// }

.edit-floorplan-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {
    overflow: hidden;

    .edit-floorplan-popup-content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .vs-select--input {
    padding: 4px !important;
  }

  .vs-input--input {
    padding: 4px !important;
  }
}
</style>
